import React, { FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  title: string
  placeholder?: string
}

const TextField: FC<Props> = ({ title, placeholder }) => {
  return (
    <Box width="full" gap="s24" flexDirection="row">
      <Box width="full" gap="s4">
        <Text.Normal size="200" weight="medium" color="grey1000">
          {title}
        </Text.Normal>
        <Box
          background="grey000White"
          padding="s16"
          borderRadius={{ all: 'abs008' }}
          flexDirection="row"
          justifyContent="spaceBetween"
          alignItems="center"
          border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
        >
          {placeholder ? (
            <Text.Normal color="grey600">{placeholder}</Text.Normal>
          ) : (
            <Box padding="s4" />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default TextField
